// This is a 32-bit RGBA image.
// Might be good to switch to 24 bit instead since we don't use alpha channel?
// Would cut down on processing and use less memory. However, interop with:
//  - open cv
//  - canvas
//  - parsing png/jpeg, etc.
// might be slower which might negate any gains. Test it out.
// Note that there are 2 methods of using this bitmap. One is if a build image
// the other is for rendering. 32 is probably better for rendering, but 24 might
// be better for building.
// TODO: Consider switching to imagedata. Would provide some small optimisations in
// rendering, and perhaps some other operations
type Bitmap = {
	readonly data: Pick<
		Uint8Array,
		"slice" | "subarray" | "copyWithin" | "length"
	> & {
		readonly [key in number]: number;
	};
	readonly width: number;
	readonly height: number;
};

type WritableBitmap = {
	// One day maybe use Uint8Array instead?
	readonly data: Uint8Array;
	readonly width: number;
	readonly height: number;
};

const bitmapChannels = 4;

/**
 * Performs bitwise NOT operation on a WritableBitmap in-place.
 * This inverts all pixel values (255 - value for each channel).
 * @param bitmap - The bitmap to perform the operation on
 */
function bitwiseNot(bitmap: WritableBitmap): void {
	const { data } = bitmap;
	const length = data.length;

	for (let i = 0; i < length; i++) {
		data[i] = 255 - data[i];
	}
}

export { bitmapChannels, bitwiseNot };
export type { WritableBitmap, Bitmap };
